import axios from 'services/index';
import config from 'config/config';

/**
 * Retrieves the vet's team representatives
 */
async function getVetDetails() {
    return axios.get(`${config.API_URL}portal/vet`);
}

/**
 * Updates the Price option of the vet
 */
async function updateVetDetails(data) {
    return axios.post(`${config.API_URL}portal/vet`, data);
}

/**
 * Submit the add booking vet supply order
 */
async function getTeamRepresentative() {
    return axios.get(`${config.API_URL}portal/vet/account_manager`);
}

/**
 * Retrieves the vet's service types
 */
async function getServiceTypes() {
    return axios.get(`${config.API_URL}portal/vet/service_types`);
}

export default {
    getVetDetails,
    updateVetDetails,
    getServiceTypes,
    getTeamRepresentative
};
